<div *transloco="let t">
  <h1 mat-dialog-title class="text-3xl font-semibold tracking-tight leading-8">{{ t('select') | titlecase }} {{ t('company') }}</h1>
  <mat-dialog-content>
    <form class="mt-6" [formGroup]="form" noValidate autocomplete="off">
      <hmax-input-text-autocomplete
        placeholder="select-company"
        [formGroup]="form"
        controlName="company"
        [options]="companies"
        [startOpened]="false"
      >
      </hmax-input-text-autocomplete>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="gap-2">
    @if (isSuperUser) {
      <button
        mat-button
        [mat-dialog-close]
        class="w-full sm:w-auto sm:inline-flex mt-4 sm:mt-0 ml-0 sm:ml-3"
        mat-stroked-button
        (click)="changeCurrentCompany(null)"
      >
        {{ t('continue') | titlecase }} {{ t('without-company') }}
      </button>
    }
    <button
      class="w-full sm:w-auto sm:inline-flex mt-4 sm:mt-0 ml-0 sm:ml-3 dark:text-white dark:enabled:bg-blue-600 dark:disabled:bg-gray-700"
      mat-flat-button
      [color]="'primary'"
      [disabled]="form.disabled || !form.get('company')?.value"
      (click)="onSelectClick()"
    >
      {{ t('select') | titlecase }}
    </button>
  </mat-dialog-actions>
</div>
